module.exports = __webpack_public_path__ + "static/media/salesforceProcess3.9de7e4ef.png";